import { createComponent } from '@carvana/merch-components';
import SuccessCheck from '~/icons/SuccessCheck';

export const ImageContainer = createComponent('div', {
  className: `
    flex-center
    relative
    flex
    h-[126px]
    w-full
    before:absolute
    before:bottom-0
    before:left-0
    before:right-0
    before:top-0
    before:rounded-xl
    before:content-[""]
    m:h-[191px]
    l:h-[556px]
    l:max-w-[456px]
  `
});

export const SkyImage = createComponent('img', {
  className: `
    max-h-[104px]
    w-full
    self-center
    rounded-xl
    transition-all
    duration-500
    ease-in-out
    m:mt-8
    m:max-h-[156px]
    m:self-start
    l:mt-0
    l:max-h-full
    l:max-w-[442px]
  `
});

export const StyledSuccessCheck = createComponent(SuccessCheck, {
  className: `
    h-32
    w-32
    rounded-full
    border
    border-green-2
    bg-green-2
    transition
    duration-200
    ease-in-out
    m:h-56
    m:w-56
    l:h-80
    l:w-80
  `
});
